import React from 'react';
import cx from 'classnames';
import styles from './itemDivider.module.less';

/** Divider between items in the cart  */
export const ItemDivider = ({ className }: { className?: string }) => {
  return <div className={cx(styles.itemDivider, className)} />;
};
